import { OrderCheckoutType } from "./orderCheckoutType";

export enum OrderStepType {
	PERSONAL_DATA = 'personal_data',
	ADDRESS = 'address',
	PAYMENT = 'payment',
	SUBSCRIPTION = 'subscription',
	COMPLETED = 'information'
}

export const getStepInfo = (checkoutType: OrderCheckoutType, currentStep: OrderStepType): { steps: OrderStepType[], currentIndex: number } => {
	const stepsMap: Record<OrderCheckoutType, OrderStepType[]> = {
	  [OrderCheckoutType.PREPAID]: [
		OrderStepType.PERSONAL_DATA,
		OrderStepType.ADDRESS,
		OrderStepType.PAYMENT,
		OrderStepType.SUBSCRIPTION,
		OrderStepType.COMPLETED
	  ],
	  [OrderCheckoutType.SUBSCRIPTION]: [
		OrderStepType.PERSONAL_DATA,
		OrderStepType.ADDRESS,
		OrderStepType.SUBSCRIPTION,
		OrderStepType.COMPLETED
	  ],
	  [OrderCheckoutType.POSTPAID]: [
		OrderStepType.PERSONAL_DATA,
		OrderStepType.ADDRESS,
		OrderStepType.SUBSCRIPTION,
		OrderStepType.PAYMENT,
		OrderStepType.COMPLETED
	  ],
	};
  
	const steps = stepsMap[checkoutType] || [];
	const currentIndex = steps.indexOf(currentStep);

	// Ajusta o índice para começar em  1 em vez de  0
	const adjustedIndex = currentIndex +  1;
	return { steps, currentIndex: adjustedIndex };
  };